import { resolveName } from 'components/form/final-form/hooks/useField'
import { MetaPath } from 'util/metaPath'

export const resolveLabelKey = <TFieldModel>(fieldName: MetaPath<TFieldModel>) =>
  resolveName(fieldName).replaceAll('.', '.fields.')
